import { Analytics } from './analytics';

let domain = document.location.hostname;

if (domain.split('.').length > 2) {
    domain = domain.split('.').slice(-2).join('.');
}

let outboundUrl = $(`a[href*='${domain}']`);

outboundUrl.click((e) => {
    const linkUrl = e.currentTarget.getAttribute('href');

    Analytics.sendRawEvent({
        "event": "click",
        "interaction": {
            "link_domain": new URL(linkUrl).hostname,
            "click_type": "link",
            "link_url": linkUrl,
            "link_text": e.currentTarget.innerText
        }
    });
});